// Angular Imports
import { Component, inject, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";

// Services
import { CookieBridgeService } from "#services/cookie-bridge/cookie-bridge.service";
import { UpdateWorkerService } from "#services/update-worker/update-worker.service";
import { TranslationService } from "#services/translation/translation.service";
import { ThemeService } from "#services/theme/theme.service";
import { AuthService } from "#services/auth/auth.service";

@Component({
    selector: "app-root",
    imports: [RouterOutlet],
    templateUrl: "./app.component.html",
    styleUrl: "./app.component.scss",
    standalone: true,
})
export class AppComponent implements OnInit {
    loading = true;
    translation: object | null = null;

    private readonly cookieService = inject(CookieBridgeService);
    private readonly themeService = inject(ThemeService);
    public readonly authService = inject(AuthService);
    public readonly translationService = inject(TranslationService);
    private updateService = inject(UpdateWorkerService);

    constructor() {
        this.themeService.themeName.set(this.cookieService.get("theme") || "default");
        this.updateService.init();
    }

    async ngOnInit() {
        await this.themeService.loadTheme();
        this.translation = await this.translationService.loadTranslations();

        this.loading = false;
    }
}
